// Web push helpers for Precision Wealth daily quiz reminders.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getRegistration() {
  if (!('serviceWorker' in navigator)) return null;
  return navigator.serviceWorker.ready;
}

// Requests permission, subscribes via PushManager, and saves the subscription to the backend.
export async function enablePush(token, vapidPublicKey) {
  if (!pushSupported()) throw new Error('unsupported');
  if (!window.isSecureContext) throw new Error('insecure');

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('denied');

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });
  }
  await axios.post(`${API}/notifications/push/subscribe`, subscription.toJSON(), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return true;
}

export async function disablePush(token) {
  let endpoint = null;
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      endpoint = subscription.endpoint;
      await subscription.unsubscribe();
    }
  } catch (e) { /* ignore */ }
  await axios.post(`${API}/notifications/push/unsubscribe`, { endpoint }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return true;
}
